import { Observable } from 'rxjs';
import {
  ApiService,
  GET_NOTIFICATION_PREFERENCES_PATH,
  GetNotificationPreferencesResponse,
  TOGGLE_NOTIFICATION_PREFERENCE_PATH,
  ToggleNotificationPreferenceBody,
  ToggleNotificationPreferencePathParams,
  ToggleNotificationPreferenceResponse
} from '@core-http';

export class NotificationsPreferencesService extends ApiService {
  getPreferences(): Observable<GetNotificationPreferencesResponse> {
    return this.httpClient.get<GetNotificationPreferencesResponse>(
      `${this.env.apiUrl}${GET_NOTIFICATION_PREFERENCES_PATH}`
    );
  }

  togglePreference(
    pathParams: ToggleNotificationPreferencePathParams,
    body: ToggleNotificationPreferenceBody
  ): Observable<ToggleNotificationPreferenceResponse> {
    const path: string = this.fillPathParams(TOGGLE_NOTIFICATION_PREFERENCE_PATH, pathParams);

    return this.httpClient.patch<ToggleNotificationPreferenceResponse>(`${this.env.apiUrl}${path}`, body);
  }
}
